export default "__VITE_ASSET__5z4sFmIA__"